/**
 * Claves del payload que pueden traer la posición reportada, en orden de preferencia.
 *
 * El firmware nuevo publica `pos` (el ítem del wire es `{ts, rid, mid, gid, opn, n, code, tgt,
 * pos0, pos, dir, dts}`) y las filas legacy que ya están en producción traen `position`. Hay que
 * leer las dos: quedarse con una sola no lanza nada, simplemente no encuentra la posición
 * (AMARU-887).
 */
const POSITION_KEYS = ['pos', 'position'] as const;

/**
 * Posición reportada por un mensaje: la primera de `POSITION_KEYS` con un valor numérico finito.
 *
 * `0` es una posición válida (compuerta cerrada), así que el descarte es por tipo y finitud, no
 * por falsy. Un string —aunque sea `'12'`— se descarta a propósito: el payload es JSON del
 * dispositivo y aceptar strings taparía un cambio de contrato en vez de hacerlo visible.
 *
 * Es el espejo de `readPayloadPosition` del backend
 * (`backend/src/services/gateMovement/position.ts`) y tiene que seguir siéndolo. Las dos
 * implementaciones ya se separaron una vez: el backend pasó a leer `pos` y esta se quedó en
 * `position`, y el resultado fue un panel que decía «posición ?» en todos los mensajes, sin que
 * nada fallara ni se notara hasta probar contra una compuerta real. Si cambia el criterio de una,
 * cambia el de la otra.
 */
export const readPayloadPosition = (payload: unknown): number | null => {
  if (payload == null || typeof payload !== 'object') return null;
  const record = payload as Record<string, unknown>;
  for (const key of POSITION_KEYS) {
    const value = record[key];
    if (typeof value === 'number' && Number.isFinite(value)) return value;
  }
  return null;
};
